import moment from 'moment';
import React, { FC, Fragment } from 'react';
import { useNonogramDailyTopTimesByMonth } from '@games/api';
import { FormattedMessage } from 'react-intl';
import messages from 'intl/messages';
import MyLink from 'features/home/components/MyLink';
import Loader from './Loader';
import {
  firstDailyPuzzleYear,
  firstDailyPuzzleMonth,
  firstDailyPuzzleDay,
} from '../constants';

interface DailyTimePageProps {
  match: {
    params: {
      year?: string;
      month?: string;
    };
  };
}

// TODO: Update this to be the start of daily puzzles

export const DailyArchivePage: FC<DailyTimePageProps> = ({
  match: { params: { year, month, } },
}) => {
  const yearNum = parseInt(year ?? moment().format('YYYY'), 10);
  const monthNum = parseInt(month ?? moment().format('MM'), 10);
  const m = moment().year(yearNum).month(monthNum - 1);
  const [{ data, loading }] = useNonogramDailyTopTimesByMonth(
    yearNum,
    monthNum,
  );

  const showPrevious = !(
    yearNum === firstDailyPuzzleYear && monthNum === firstDailyPuzzleMonth
  );
  const showNext = !(
    yearNum === moment().year() && monthNum === moment().month() + 1
  );

  const goToPrevious = () => {
    const prev = m.clone().subtract(1, 'month');
    window.location.href = `/daily/archive/${prev.format('YYYY-MM')}`;
  };

  const goToNext = () => {
    const next = m.clone().add(1, 'month');
    window.location.href = `/daily/archive/${next.format('YYYY-MM')}`;
  };

  return (
    <div>
      <h1 className='text-2xl font-bold mb-4 text-center'>
        <FormattedMessage {...messages.dailyPuzzleArchive} />
      </h1>
      <div className='grid grid-cols-3 items-center my-4'>
        {showPrevious ? (
          <div>
            <button
              className='bg-blue-500 text-white px-4 py-2 rounded'
              onClick={goToPrevious}
            >
              <FormattedMessage {...messages.previous} />
            </button>
          </div>
        ) : (
          <div />
        )}
        <p className='text-center'>{m.format('MMMM YYYY')}</p>
        {showNext ? (
          <div className='text-right'>
            <button
              className='bg-blue-500 text-white px-4 py-2 rounded'
              onClick={goToNext}
            >
              <FormattedMessage {...messages.next} />
            </button>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div className='grid grid-cols-3 gap-4'>
            <div>
              <strong>
                <FormattedMessage {...messages.day} />
              </strong>
            </div>
            <div className='text-center'>
              <strong>
                <FormattedMessage {...messages.size} />
              </strong>
            </div>
            <div className='text-right'>
              <strong>
                <FormattedMessage {...messages.fastestTime} />
              </strong>
            </div>
            {data ? Object.entries(data).map(([day, info]) => {
              if (
                monthNum === firstDailyPuzzleMonth &&
                yearNum === firstDailyPuzzleYear &&
                parseInt(day, 10) < firstDailyPuzzleDay
              ) {
                return null;
              }
              return (
                <Fragment
                  key={day}
                >
                  <MyLink
                    href={`/daily/${info.date}`}
                    className='text-lg font-bold'
                  >
                    {moment(info.date).format('MMM D, YYYY')}
                  </MyLink>
                  <p className='text-center'>
                    <FormattedMessage {...messages.size} />:
                    {' '}
                    {info.size}x{info.size}
                  </p>
                  <p className='text-right'>
                    {info.fastestTime !== null
                      ? info.fastestTime
                      : 'No times yet'}
                  </p>
                </Fragment>
              );
            }) : (
              <div className='col-span-3 text-center'>
                <FormattedMessage {...messages.noPuzzlesFound} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};